import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-should-login',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './should-login.component.html',
  styleUrl: './should-login.component.scss'
})
export class ShouldLoginComponent {
  version: string | null = environment.version;
  constructor(private oAuthService: OAuthService) {
  }

  public login($event: any) {
    $event.preventDefault();
    this.oAuthService.initLoginFlow();
  }
}
